/* SHARED — SET DEAL ladder math + volume copy, all widths.
 * Policy: docs/mobile-desktop-split.md
 * Volume-tier set deal — shared next-rung math and live paint.
 *
 * Kick-ins (locked 2026-09-10): 10% at 3+ · 15% at 6+ · 25% at 8+ · 30% at 12+ (12+ was 40% until the October 2026 sale)
 * ⛔ Do not render ranges (3–4 / 5–7 / 8–11). The sticky bar stays short — no strip in the bar.
 * ⛔ Never announce "30% off" as a current saving below 12 tiles.
 */
(function () {
  'use strict';

  var KICKS = [
    { at: 3, pct: 10 },
    { at: 6, pct: 15 },
    { at: 8, pct: 25 },
    { at: 12, pct: 30 }
  ];

  function nudge(n) {
    n = Number(n) || 0;
    if (n <= 0) return 'Add 3 to unlock 10%';
    if (n === 1) return 'Add 2 more to unlock 10%';
    if (n === 2) return 'Add 1 more to unlock 10%';
    if (n < 6) return 'Add ' + (6 - n) + ' more to unlock 15%';
    if (n < 8) return 'Add ' + (8 - n) + ' more to unlock 25%';
    if (n < 12) return 'Add ' + (12 - n) + ' more to unlock 30%';
    return '30% unlocked on this set.';
  }

  function cartHeadline(n) {
    n = Number(n) || 0;
    if (n <= 0) return 'Add 3 to unlock 10%';
    if (n === 1) return 'Add 2 more to unlock 10%';
    if (n === 2) return 'Add 1 more to unlock 10%';
    if (n < 6) return '10% unlocked. Add ' + (6 - n) + ' more to unlock 15%';
    if (n < 8) return '15% unlocked. Add ' + (8 - n) + ' more to unlock 25%';
    if (n < 12) return '25% unlocked. Add ' + (12 - n) + ' more to unlock 30%';
    return '30% unlocked on this set.';
  }

  function rung(n) {
    n = Number(n) || 0;
    if (n >= 12) return 30;
    if (n >= 8) return 25;
    if (n >= 6) return 15;
    if (n >= 3) return 10;
    return 0;
  }

  function unitPriceCents(base, n) {
    base = Number(base) || 0;
    return Math.round(base * (100 - rung(n)) / 100);
  }

  function displayPct(n) {
    var r = rung(n);
    return r === 0 ? 30 : r;
  }

  function fillPct(n) {
    n = Math.max(0, Number(n) || 0);
    return Math.min(100, (n / 12) * 100);
  }

  function nextAt(n) {
    n = Number(n) || 0;
    if (n < 3) return 3;
    if (n < 6) return 6;
    if (n < 8) return 8;
    if (n < 12) return 12;
    return 0;
  }

  function isStandItem(item) {
    if (!item) return false;
    if (item.handle === 'desk-stand') return true;
    if (item.handle === 'rush') return true;
    if (item.sku === 'DF3D-STAND') return true;
    if (item.sku === 'RUSH-5') return true;
    if (item.product_type === 'Accessory') return true;
    return false;
  }

  function countTiles(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (n, it) {
      return n + (isStandItem(it) ? 0 : (it.quantity || 0));
    }, 0);
  }

  function money(cents) {
    var n = Number(cents) || 0;
    return '$' + (n / 100).toFixed(2);
  }

  function paintUnitPrices(units) {
    var els = document.querySelectorAll('[data-volume-unit-price]');
    for (var i = 0; i < els.length; i++) {
      var base = parseInt(els[i].getAttribute('data-volume-base-cents'), 10);
      if (!base) continue;
      var shown = unitPriceCents(base, units);
      els[i].textContent = money(shown);
    }
    var lists = document.querySelectorAll('[data-volume-list-price]');
    for (var j = 0; j < lists.length; j++) {
      var sibling = lists[j].parentElement && lists[j].parentElement.querySelector('[data-volume-unit-price]');
      var listBase = sibling ? parseInt(sibling.getAttribute('data-volume-base-cents'), 10) : 0;
      if (!listBase) continue;
      lists[j].textContent = money(listBase);
      if (rung(units) > 0) lists[j].removeAttribute('hidden');
      else lists[j].setAttribute('hidden', '');
    }
  }

  function paintKickRows(root, units) {
    if (!root) return;
    var current = rung(units);
    var rows = root.querySelectorAll('[data-volume-strip] [data-volume-kick]');
    for (var i = 0; i < rows.length; i++) {
      var pct = parseInt(rows[i].getAttribute('data-volume-kick'), 10);
      var on = pct === current;
      rows[i].classList.toggle('text-primary', on);
      rows[i].classList.toggle('text-muted-foreground', !on);
    }
  }

  function paintWidget(root, units) {
    if (!root) return;
    var r = rung(units);
    var shown = displayPct(units);
    var nxt = nextAt(units);

    var pctEl = root.querySelector('[data-volume-pct]');
    if (pctEl) pctEl.textContent = shown + '%';
    var upto = root.querySelector('[data-volume-upto]');
    if (upto) {
      if (r > 0) upto.setAttribute('hidden', '');
      else upto.removeAttribute('hidden');
    }

    var fill = root.querySelector('[data-volume-fill]');
    if (fill) fill.style.width = fillPct(units) + '%';

    var nodes = root.querySelectorAll('[data-volume-node]');
    for (var i = 0; i < nodes.length; i++) {
      var at = parseInt(nodes[i].getAttribute('data-volume-at'), 10);
      var unlocked = units >= at;
      nodes[i].classList.toggle('is-on', unlocked);
      nodes[i].classList.toggle('is-next', !unlocked && at === nxt);
      var check = nodes[i].querySelector('[data-volume-check]');
      if (check) {
        if (unlocked) check.removeAttribute('hidden');
        else check.setAttribute('hidden', '');
      }
    }

    root.setAttribute('data-volume-units', String(units));
  }

  function paint(units) {
    units = Number(units) || 0;
    var next = nudge(units);
    var head = cartHeadline(units);

    var nudgeEls = document.querySelectorAll('[data-volume-atc-nudge], [data-volume-live-nudge]');
    for (var i = 0; i < nudgeEls.length; i++) nudgeEls[i].textContent = next;

    var widgets = document.querySelectorAll('[data-volume-widget]');
    for (var w = 0; w < widgets.length; w++) {
      var widgetHead = widgets[w].querySelector('[data-volume-headline]');
      if (widgetHead) {
        var inCart = widgets[w].closest('[data-volume-cart]');
        widgetHead.textContent = inCart ? head : next;
      }
      paintWidget(widgets[w], units);
    }

    var heads = document.querySelectorAll('[data-volume-headline]');
    for (var h = 0; h < heads.length; h++) {
      if (heads[h].closest('[data-volume-widget]')) continue;
      heads[h].textContent = head;
    }

    var counts = document.querySelectorAll('[data-volume-count]');
    for (var c = 0; c < counts.length; c++) {
      if (units === 0) counts[c].textContent = 'Mix Standard, Large & GPX Hexes';
      else if (units === 1) counts[c].textContent = '1 hex in this set';
      else counts[c].textContent = units + ' hexes in this set';
    }

    paintKickRows(document, units);
    paintUnitPrices(units);

    var browse = document.querySelector('[data-volume-browse]');
    if (browse) browse.textContent = units === 0 ? 'Browse circuits' : 'Add another circuit';
  }

  function paintFromBuilder() {
    var box = document.querySelector('[data-volume-box]');
    var inCart = box ? parseInt(box.getAttribute('data-volume-cart-units'), 10) || 0 : 0;
    var builder = (window.DF3D && window.DF3D.totalTiles) ? window.DF3D.totalTiles() : 0;
    paint(inCart + builder);
  }

  function bindBuilder() {
    if (!document.querySelector('[data-volume-box]')) return;
    paintFromBuilder();
    var list = document.querySelector('[data-hex-list]');
    if (list && window.MutationObserver) {
      new MutationObserver(paintFromBuilder).observe(list, { childList: true, subtree: true });
    }
  }

  function bindCart() {
    if (!document.querySelector('[data-volume-cart]')) return;

    function refreshLine(wrap, qty) {
      var line = wrap.getAttribute('data-cart-line');
      var disp = wrap.querySelector('[data-cart-qty-display]');
      var plus = wrap.querySelector('[data-cart-plus]');
      var dec = wrap.querySelector('[data-cart-minus]');
      if (disp) disp.textContent = qty;
      if (plus) {
        plus.setAttribute('data-cart-qty', String(qty + 1));
        plus.setAttribute('href', '/cart/change?line=' + line + '&quantity=' + (qty + 1));
      }
      if (dec) {
        dec.setAttribute('data-cart-qty', String(Math.max(0, qty - 1)));
        dec.setAttribute('href', '/cart/change?line=' + line + '&quantity=' + Math.max(0, qty - 1));
        dec.textContent = qty > 1 ? '−' : '×';
      }
    }

    function applyCart(cart) {
      if (!cart) return;
      paint(countTiles(cart));
      var lines = document.querySelectorAll('[data-cart-line]');
      if (cart.items.length !== lines.length) {
        window.location.reload();
        return;
      }
      for (var i = 0; i < lines.length; i++) {
        var item = cart.items[i];
        if (!item) continue;
        refreshLine(lines[i], item.quantity);
        var row = lines[i].closest('[data-cart-row]');
        var linePrice = row && row.querySelector('[data-cart-line-price]');
        if (linePrice) linePrice.textContent = money(item.final_line_price);
      }
      var sub = document.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price) + ' USD';
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-plus], [data-cart-minus]');
      if (!btn) return;
      var wrap = btn.closest('[data-cart-line]');
      if (!wrap) return;
      e.preventDefault();
      var line = parseInt(wrap.getAttribute('data-cart-line'), 10);
      var next = parseInt(btn.getAttribute('data-cart-qty'), 10);
      if (!line || next < 0) return;
      if (next === 0) {
        window.location.href = btn.getAttribute('href') || '/cart/change?line=' + line + '&quantity=0';
        return;
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: next })
      }).then(function (r) { return r.json(); }).then(applyCart).catch(function () {
        window.location.href = btn.getAttribute('href');
      });
    });
  }

  window.DF3DVolume = {
    nudge: nudge,
    cartHeadline: cartHeadline,
    rung: rung,
    kicks: KICKS,
    paint: paint,
    paintFromBuilder: paintFromBuilder,
    countTiles: countTiles,
    fillPct: fillPct,
    displayPct: displayPct,
    nextAt: nextAt,
    unitPriceCents: unitPriceCents
  };

  document.addEventListener('DOMContentLoaded', function () {
    bindBuilder();
    bindCart();
  });
})();
